import { render, staticRenderFns } from "./ShapeTripleConstraint.vue?vue&type=template&id=21ae0a86&"
import script from "./ShapeTripleConstraint.vue?vue&type=script&lang=js&"
export * from "./ShapeTripleConstraint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports